// import Vue from 'vue'
import InstillingerService from './InstillingerService'
import _ from 'lodash'

export default {
  /**
   * Used in Instillinger Files
   *
   */
  loadDropdownExpertavdeling: function (avdelingsId) {
    return new Promise((resolve, reject) => {
      InstillingerService('expertavdeling').dropdownByParams({ avdeling: avdelingsId })
        .then((response) => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  loadDropdownKategori: function (params = {}) {
    return new Promise((resolve, reject) => {
      InstillingerService('kategori').dropdown('key', params)
        .then((response) => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  loadDropdownLabels: function () {
    return new Promise((resolve, reject) => {
      InstillingerService('label').dropdown()
        .then((response) => {
          this.flattenTree(response.data, [], function (flattened) {
            let payload = {
              tree: response.data,
              flat: flattened
            }

            resolve(payload)
          })
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  flattenTree: function (inArray, toArray, callback) {
    if (typeof inArray === 'object' && inArray.length > 0) {
      inArray.forEach((item) => {
        if (item.children && item.children.length > 0) {
          this.flattenTree(item.children, toArray)
        }

        toArray.push(_.omit(item, 'children'))
      })
    }

    if (callback) {
      callback(toArray)
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/MiscService.js